import React from 'react';
import { Container, Typography, Box, Grid, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import Banner from "../components/Banner";
import Carousel3D from "./../components/Carousel3D";
import WhiteButton from './../components/WhiteButton.tsx';
import CarouselArticulos from './../components/CarouselArticulos';
import { useEffect, useState } from 'react';
import AlianzaLeCosy from '../components/AlianzaLecosy.js';
import { fetchAllBlogPosts } from './../components/wordpressUtils';
import BannerHub from './../components/BannerHub.js';
import { Helmet } from 'react-helmet'
export default function Home() {
  const [wordpressArticles, setWordpressArticles] = useState([]);
  const [isLoadingArticles, setIsLoadingArticles] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingArticles(true);
        const wpArticles = await fetchAllBlogPosts();
        setWordpressArticles(wpArticles);
      } catch (err) {
        console.error('Error al obtener artículos:', err);
      } finally {
        setIsLoadingArticles(false);
      }
    };

    fetchData();
  }, []);

  return (
      <>
    <Helmet>
      <title>Inicio | EBM Consultores</title>
      <meta
        name="description"
        content="Consultoría especializada en Empresa Familiar, Gobierno Corporativo y Legado Patrimonial. Descubre cómo acompañamos tu evolución."
      />
    </Helmet>
    <Container sx={{ margin: '0', padding: '0 !important', maxWidth: '100vw !important' }}>
      <Box>
        <Banner
          backgroundImage="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744216083/ebm/banner-home_secmp5.png"
          title={
            <Typography
              sx={{
                color: 'white',
                padding: "0px 20px",
                borderRadius: "5px",
                display: "inline-block",
                fontSize: { xs: '24px', sm: '30px', md: '50px' },
                maxWidth: { sm: '700px', md: '937px' },
                textShadow: '0px 2px 10px rgb(0,0,0,0.5)',
              }}
            >
              un{" "}
              <Box
                component="span"
                sx={{
                  position: 'relative',
                  px: '2vw',
                  borderRadius: '50rem',
                  background: 'linear-gradient( rgba(10, 98, 116, 0), rgba(10, 98, 116, 0.5))',
                  color: 'white',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(10px)',
                  WebkitBackdropFilter: 'blur(10px)',
                  boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
                  transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
                  fontWeight: 500,
                  zIndex: 1,
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    padding: '1px',
                    borderRadius: '50rem',
                    background: 'linear-gradient(90deg, #0ff, rgba(10, 98, 116, 0))',
                    WebkitMask:
                      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                    WebkitMaskComposite: 'xor',
                    maskComposite: 'exclude',
                    zIndex: -1,
                    transition: 'opacity 0.3s ease',
                  },
                  '&:hover': {
                    boxShadow:
                      '0px -1px 3px rgba(255, 255, 255, 0.3), 0px 2px 10px rgba(0,0,0,0.5)',
                    background:
                      'linear-gradient(0deg, rgba(10, 98, 116, 0.5), rgba(10, 98, 116, 0.4))',
                    '&::before': {
                      opacity: 0,
                    },
                  },
                }}
              >
                aliado comprometido
              </Box>
              {" "}con la evolución de
              <strong> tu legado</strong>
            </Typography>
          }
          subtitle="Más que una consultoría,"
          subtitlePosition="top"
          variant="centered"
          extraContent={
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                py: 2,
                px: "5px",
                width: "100%",
                background: "rgba(10, 98, 116, 1)",
                mixBlendMode: 'overlay',
                textAlign: "justify",
              }}
              className='overlay'
            >
              <Typography sx={{ color: 'white', fontSize: { xs: '16px', sm: '20px', md: '22px' }, textAlign: 'center', textShadow: '0px 2px 10px rgb(0,0,0,0.5)', }}>CONSULTORÍA DE NEGOCIOS</Typography>
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          height: '246px',
          width: "100%",
          background: { xs: 'linear-gradient(to left,  #38383D 0%,rgba(0,0,0,1) 30%,rgba(0,0,0,1) 70%, #38383D 100%)', md: "linear-gradient(to left,  #38383D 0%,rgba(0,0,0,1) 10%,rgba(0,0,0,1) 70%, #38383D 100%)" },
          textAlign: "justify",
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: { xs: '100%', md: '70%' }, px: { xs: '40px', md: '100px' } }}>
          <Typography sx={{ color: 'white', fontSize: { xs: '16px', md: '18px' }, textAlign: 'justify', textShadow: '0px 2px 10px rgb(0,0,0,0.5)', }}>
            En EBM Consulting fortalecemos la familia, la empresa y el patrimonio. Implementamos estrategias para un desarrollo sostenible, con enfoque en resultados y compromiso constante. Somos socios en el éxito, dedicados a alcanzar juntos la visión de nuestros clientes.
          </Typography>
        </Box>
        <Box
          sx={{
            position: 'absolute',
            bottom: { xs: 0, md: '-253px' },
            right: 0,
            display: { xs: 'none', md: 'inline' },
            width: '30vw',
          }}
        >
          <img
            src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744311758/ebm/image-banner_txi7ra.png"
            alt="Banner Home"
            style={{ height: 'auto', width: '100%' }}
          />
        </Box>
      </Box>

      <Box sx={{
        backgroundColor: { xs: '#DEDEDE', md: 'transparent' },
        backgroundImage: {
          xs: 'url("https://res.cloudinary.com/dhoyyqszi/image/upload/v1744216088/ebm/secc1-image_ym9akc.png")',
          md: 'url("https://res.cloudinary.com/dhoyyqszi/image/upload/v1744216085/ebm/secc1-bar_amgkw5.png")',
        },
        backgroundSize: { xs: 'contain', md: '1400px 531px' },
        backgroundPosition: { xs: 'right top', md: '-150px center', lg: '-100px center', xl: 'left' },
        backgroundRepeat: 'no-repeat',
        height: { md: '700px' },
        width: '100%',
      }}>
        <Box sx={{ py: { xs: '50px', md: '0' }, px: { xs: '50px', md: '0px' }, maxWidth: { xs: '100%', md: '544px' }, textAlign: 'justify', display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%', marginLeft: { md: '300px', lg: '390px', xl: '490px' } }}>
          <Typography sx={{ color: { md: 'white' }, fontSize: { xs: '20px', md: '24px' }, py: '20px' }}><strong>Juntos </strong>en cada paso del camino</Typography>
          <Typography>
            Nuestro compromiso va más allá de la asesoría, <strong>queremos ser ese aliado estratégico que estas buscando</strong>. Cada acción que tomamos está impulsada por un profundo entendimiento de los objetivos que deseas alcanzar. Nos enfocamos en asegurar que tu legado se construya sobre bases sólidas que perduren. Nuestra promesa es acompañarte de manera cercana, siempre escuchando, aprendiendo y adaptando nuestras soluciones a las necesidades únicas de tu familia, empresa y patrimonio.
            <br /><br />
            <strong>
              Trabajamos con la certeza de que un futuro sostenible se logra con decisiones estratégicas, pensadas a largo plazo, que reflejan la verdadera esencia de lo que desea construir.
            </strong>
          </Typography>
        </Box>
      </Box>

      <Box sx={{
        backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1744216089/ebm/secc2-background_e2rluh.png)',
        backgroundRepeat: "no-repeat",
        backgroundSize: { xs: 'cover', lg: "100%" },
        backgroundPosition: { xs: "top center", lg: "top left" },
        backgroundColor: 'black',
        color: 'white',
        paddingBottom: { lg: '1em' },
        display: 'flex',
        justifyContent: 'center'
      }}>
        <Grid container sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'space-around' }, alignItems: 'center', textAlign: 'justify', gap: 10, py: 8, maxWidth: '1500px' }}>
          <Grid item xs={10} md={6} lg={5}>
            <Box>
              <Typography sx={{ fontWeight: 100 }}>
                Nuestros fundamentos
              </Typography>
              <Typography sx={{ fontSize: { xs: '28px', sm: '32px' }, pb: { xs: 3, md: 5 } }}>
                <strong>Tres</strong>  {" "}
                <Box
                  component="span"
                  sx={{
                    position: 'relative',
                    px: '1rem',
                    borderRadius: '15px',
                    background: '#84BFCB',
                  }}
                >
                  ejes de acción
                </Box>
              </Typography>
              <Typography sx={{ pb: { xs: 2, md: 0 } }}>
                En EBM Consulting, centramos nuestras acciones en tres pilares esenciales: <br />
                <Link to="/ejes-de-accion/familia" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <strong>familia</strong>
                </Link>
                {', '}
                <Link to="/ejes-de-accion/empresa" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <strong>empresa</strong>
                </Link>
                {' y '}
                <Link to="ejes-de-accion/propiedad" style={{ color: 'inherit', textDecoration: 'none' }}>
                  <strong>propiedad</strong>
                </Link>
                {'. '}
                <br /><br />
                Fortalecemos la unidad familiar, impulsamos el crecimiento empresarial y protegemos el patrimonio, construyendo juntos una base sólida para un legado que trascienda.
              </Typography>

              {/* BOTÓN DE DESCARGA - Versión completamente responsive */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  mt: { xs: 4, sm: 5, md: 6, lg: 7 },  // Margen superior responsive
                  mb: { xs: 2, md: 0 },  // Margen inferior responsive
                  px: { xs: 2, sm: 0 },  // Padding horizontal en móviles
                  '& img': {
                    height: { xs: '45px', sm: '50px', md: '55px' },  // Tamaño del botón responsive
                    maxWidth: '100%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      opacity: 0.9,
                    }
                  }
                }}
              >
                <a
                  href="https://drive.google.com/file/d/1WYnkIdeJ34qxtOH9vIidX2nqCYlHZ8Uz/view?usp=sharing"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-block' }}
                >
                  <img
                    src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750090669/ebm/Group_1000004269_vsfwrz.png"
                    alt="Descarga nuestro Portafolio de Servicios"
                  />
                </a>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={10} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <img src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744216089/ebm/secc2-image_ggsluk.png" alt="Ejes de acción" style={{ height: 'auto', width: '100%', maxWidth: '500px' }} />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ backgroundColor: '#0A6274', color: 'white', pt: 10, pb: 6 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 6 }}>
          <Typography sx={{ fontSize: { xs: '28px', sm: '32px' }, pb: 2 }}>
            Construye <strong>hoy</strong> el  {" "}
            <Box
              component="span"
              sx={{
                position: 'relative',
                px: '1rem',
                borderRadius: '50rem',
                background: 'linear-gradient(25deg, #0A6274 10%, #13B8DA)',
                color: 'white',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
                transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
                fontWeight: 500,
                zIndex: 1,
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  padding: '1px',
                  borderRadius: '50rem',
                  background: 'linear-gradient(180deg, #0ff, #0A6274)',
                  WebkitMask:
                    'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  zIndex: -1,
                  transition: 'opacity 0.3s ease',
                }
              }}
            >
              éxito de mañana
            </Box>
          </Typography>
          <Typography sx={{ fontSize: '18px' }}>
            Si necesitas un plan sólido para tu familia, empresa o patrimonio, no esperes más.
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <Carousel3D />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-end' }, pr: { xs: 0, md: '15vw' } }}>
          <Typography sx={{ fontSize: '22px', letterSpacing: 2, textAlign: { xs: 'center', md: 'right' }, lineHeight: 1.2 }}>
            Permítenos <strong>acompañarte</strong> <br />en este camino.
          </Typography>
          <Box sx={{ py: 2 }}>
            <WhiteButton href="/contacto" />
          </Box>
        </Box>
      </Box>

      {/* Carrusel con artículos de WordPress */}
      <Box sx={{
        backgroundColor: 'white',
        pb: 10,
        pt: 8,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        borderBottom: '1px solid #E0E0E0'
      }}>
        <Typography sx={{
          py: 4,
          color: '#0A6274',
          fontSize: { xs: '1.6rem', md: '2rem' },
          fontWeight: 600,
          textAlign: 'center'
        }}>
          Explora nuestros <b>últimos insights</b>
        </Typography>

        {isLoadingArticles ? (
          <Box sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress color="primary" />
          </Box>
        ) : wordpressArticles.length > 0 ? (
          <CarouselArticulos wpData={wordpressArticles} />
        ) : (
          <Typography>No hay artículos disponibles</Typography>
        )}
      <BannerHub/>
      </Box>

      <AlianzaLeCosy />
    </Container>
    </>
  );
}